import axios from "axios";

const baseURL = `${process.env.REACT_APP_BACKEND_URL}/api`;
const publicApi = axios.create({ baseURL });

export default publicApi;
